export default {
  set(state, { data }) {
    state.videos = data;
  },
  show(state, { data }) {
    state.video = data;
  }
}